import ClosedBefore from '@/views/ClosedBefore.vue'
import ClosedEmpty from '@/views/ClosedEmpty.vue'
import ClosedAfter from '@/views/ClosedAfter.vue'

import routeObject from '@/router/helpers/routeObject'

const homePageAlias = { name: '', alias: '/' }

export default [
  routeObject.get(
    'ClosedBefore',
    '/przed-kampania',
    ClosedBefore,
    {
      title: 'Wybieram Dziecko - Akademia Przyszłości'
    },
    homePageAlias
  ),
  routeObject.get(
    'ClosedEmpty',
    '/brak-dzieci',
    ClosedEmpty,
    {
      title: 'Wybieram Dziecko - Akademia Przyszłości'
    },
    homePageAlias
  ),
  routeObject.get(
    'ClosedAfter',
    '/po-kampanii',
    ClosedAfter,
    {
      title: 'Wybieram Dziecko - Akademia Przyszłości'
    },
    homePageAlias
  )
]
